import React from 'react'
import { NavLink,useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CImage,
	CForm,
	CButton,
	CFormInput,CFormSelect,
	CInputGroup,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'
import { isMobile } from "react-device-detect";

const pjson 	= require('../../../package.json')
const Headersubagendaklinik = (props) => {
	const { setToken,setLoading, showToast } = props 

	//--DOM--/
	const uNavigate 			= useNavigate()
	const uDispatch 			= useDispatch()
	//--END DOM--/

	const uHeaderActionObj  	= useSelector(state => state.gInitHeaderAction)
	const uBahasaObj  			= useSelector(state => state.listBahasa)
	const uActiveroute			= useSelector(state => state.activeRoute)
	const uEfekapp				= useSelector(state => state.effectApp);
	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");

	const uSavedview			= localStorage.getItem("initKalenderview") || "BULAN";
	const uViewactive			= useSelector(state => state.Kalenderview);
	const [uInitViewactive,setInitViewactive]	= React.useState(uSavedview);
	const uCabangIDinit			= parseInt(uTokenObj.user_cabangid)||0;
	const uDatacabangArr		= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const uCabangviewArr		= uTokenObj.userhak==="FREEROLE"
		? uDatacabangArr : (uDatacabangArr.filter(vItems=>(uTokenObj.user_cabangarr||[]).includes(vItems.id)));
	const [uInpCabangid,setInpCabangid]	= React.useState(uCabangIDinit); 

	const uISTambahallowed 		= true;//((uTokenObj.userhak||"")==="FREEROLE" || (uTokenObj.userhak||"")==="ADMIN");

	const hdlKeydown = (_EV) => {
		if(_EV.which===13) {}//-*/
	}
	const hdlChangecabang = (_EV) => {
		const vCabangidvalue	= parseInt(_EV.target.value)||0;
		setInpCabangid(vCabangidvalue);

		uHeaderActionObj.cabang_id 		= vCabangidvalue;
		uHeaderActionObj.isHeaderLoad 	= true;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikViewmode = (_JENISVIEW) => {
		_JENISVIEW	= (_JENISVIEW||"BULAN").toUpperCase();

		setInitViewactive(_JENISVIEW);
		uHeaderActionObj.isHeaderView	= true;
		uHeaderActionObj.initHeaderView = _JENISVIEW;

		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikViewnav = (_JENISVIEW) => {
		_JENISVIEW	= (_JENISVIEW||"TODAY").toUpperCase();

		uHeaderActionObj.isHeaderNav	= true;
		uHeaderActionObj.initHeaderView = _JENISVIEW;

		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikTambah = () => {
		uHeaderActionObj.isHeaderTambah = true;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikReset = async() => {
		const vProses = () => {
			setInpCabangid(uCabangIDinit);

			uHeaderActionObj.cabang_id 		= uCabangIDinit;
			uHeaderActionObj.isHeaderReset 	= true;
			uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
			uDispatch({type: "set", effectApp: !uEfekapp});
		}

		vProses();	
	}

	React.useEffect(()=>{
		if(uViewactive === undefined) return;

		uDispatch({type: "set", Kalenderview: undefined});
		setInitViewactive(uViewactive);
	},[uViewactive])
	React.useEffect(()=>{
		const vNewset = uInitViewactive==="AGENDA" ? "HARI" : uInitViewactive;
		localStorage.setItem("initKalenderview",vNewset);
	},[uInitViewactive])

	//console.log("Headersubagendaklinik - uActiveroute => "+(uActiveroute));
	return (
		<>
		<div className="d-none d-lg-block">
		<CImage src={pjson.homepage+"api/images/menus_"+(uActiveroute||"").toLowerCase()+".png"} 
			className="me-2"
			height={30}/>
		{uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]||""}
		</div>

		<CForm className="d-flex justify-content-center align-items-center">
			{(uTokenObj.userhak==="FREEROLE" && uDatacabangArr.length > 1) && (
			<>
				<CFormSelect size="sm"
					value={uInpCabangid}
					onChange={(e)=>hdlChangecabang(e)}
					className="d-none d-lg-inline-block w-auto"
					id="inpcabangid">
				{uCabangviewArr.map((vItems,vKeys)=>{
					return (<option key={vKeys} value={vItems.id}>{vItems.cabang_nama}</option>)
				})}
				</CFormSelect>

				<CDropdown className="d-lg-none">
					<CDropdownToggle className="border px-2" color="transparent">
					<b>{(()=>{
						const vCabangidx = UFunc.getObjectIndeks(uCabangviewArr,uInpCabangid);
						return (uCabangviewArr[vCabangidx]||{}).cabang_kode || "UNDF";
					})()}</b>
					</CDropdownToggle>

					<CDropdownMenu className="py-0">
					{uCabangviewArr.map((vItems,vKeys)=>{	
						return (
						<CDropdownItem onClick={()=>{
							const vCabangidvalue	= parseInt(vItems.id)||0;
							setInpCabangid(vCabangidvalue);

							uHeaderActionObj.cabang_id 		= vCabangidvalue;
							uHeaderActionObj.isHeaderLoad 	= true;
							uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
							uDispatch({type: "set", effectApp: !uEfekapp});
						}} className="classcursorpointer" key={vKeys}>
							{(vItems.cabang_kode||"").toUpperCase()}
							<span className="mx-1">&middot;</span>
							{(vItems.cabang_nama||"").toUpperCase()}
						</CDropdownItem>
						)			
					})}
					</CDropdownMenu>
				</CDropdown>
				<span className="ms-1"/>
			</>
			)}

			<CFormSelect className="d-md-none"
				onChange={(e)=>hdlKlikViewmode(e.target.value)} 
				value={uInitViewactive}
				onChange={(e)=>hdlKlikViewmode(e.target.value)} 
				size="sm">
				<option value="BULAN">BULAN</option>
				<option value="MINGGU">MINGGU</option>
				<option value="HARI">HARI</option>
				<option value="AGENDA">AGENDA</option>
			</CFormSelect>

			<CInputGroup className="d-none d-md-block" size="sm">
			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>hdlKlikViewmode("BULAN")} 
				style={{minWidth:75}}
				active={uInitViewactive==="BULAN"}
				id="btnBulanview">Bulan</CButton>
			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>hdlKlikViewmode("MINGGU")} 
				style={{minWidth:75}}
				active={uInitViewactive==="MINGGU"}
				id="btnMingguview">Minggu</CButton>
			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>hdlKlikViewmode("HARI")} 
				style={{minWidth:75}}
				active={uInitViewactive==="HARI"}
				id="btnHariview">Hari</CButton>
			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>hdlKlikViewmode("AGENDA")} 
				style={{minWidth:75}}
				active={uInitViewactive==="AGENDA"}
				id="btnAgendaview">Agenda</CButton>
			</CInputGroup>
		</CForm>

		<div className="ms-1 d-flex">
			<CForm className="d-none d-lg-inline-block">
				<CInputGroup size="sm">
				<CTooltip className={isMobile?"d-none":""} content="Sebelumnya">
				<CButton size="sm" color="light" 
					className="border"
					onClick={()=>hdlKlikViewnav("PREV")} 
					id="btnBefore">
					<CIcon icon="cilChevronLeft"/>
				</CButton>
				</CTooltip>
				<CTooltip className={isMobile?"d-none":""} content="Saat Ini">
				<CButton size="sm" color="light" 
					className="border"
					onClick={()=>hdlKlikViewnav("TODAY")} 
					id="btnToday">
					<CIcon icon="cilCalendar"/>
				</CButton>
				</CTooltip>
				<CTooltip className={isMobile?"d-none":""} content="Berikutnya">
				<CButton size="sm" color="light" 
					className="border"
					onClick={()=>hdlKlikViewnav("NEXT")} 
					id="btnNext">
					<CIcon icon="cilChevronRight"/>
				</CButton>
				</CTooltip>
				</CInputGroup>
			</CForm>

			<span className="ms-2 mx-1 d-none d-lg-inline">&middot;</span>

			{(uISTambahallowed) && (
			<>
			<CTooltip content={"--"+(uBahasaObj.caption_tambahdata||"Tambah Data")}>
			<CLink onClick={()=>hdlKlikTambah()} className="classikon classikontambah classcursorpointer" />
			</CTooltip>
			<span className="d-none d-lg-inline mx-1">&middot;</span>
			</>
			)}

			<CTooltip content={"--"+(uBahasaObj.caption_resetdata||"Reset View Tampilan")}>
			<CLink onClick={()=>hdlKlikReset()} className="classikon classikonreset classcursorpointer" />
			</CTooltip>
		</div>
		</>
	)//>
}

export default Headersubagendaklinik
